import React from 'react';
import { Checkbox, RadioButton, RaisedButton, TextField } from 'material-ui';
import { seasonColors } from '../../../../../utils/contracting-preset-names-codes';
import SelectSeasonName from '../../../generic-components/select-season-name';
import DateUtils from '../../../../../utils/date-utils';
import moment from 'moment';
import R from 'ramda';

const AssignDateRanges = ({
  data,
  contractingPeriod,
  notAssignedRanges,
  onChange,
}) => {
  const existingSeasons = data.existingSeasons || [];
  const assignInProgress = (data.missingDatesIndexSelected && data.missingDatesIndexSelected.length && !isNaN(data.assignToSeasonIndex));
  const selected = data.missingDatesIndexSelected || [];
  return (<div style={{ padding: '24px 0 32px 0', width: '70%' }}>
    <b>Step One: Select Dates</b>
    <br/>
    {
      notAssignedRanges && notAssignedRanges.length > 1 && (
        <Checkbox
          label="Select All"
          labelStyle={{ fontWeight: 'bold' }}
          checked={selected.length === notAssignedRanges.length}
          onCheck={(_, inputChecked) => {
            return onChange({ keyPath: ['data', 'missingDatesIndexSelected'], value: inputChecked ? notAssignedRanges.map((__, i) => i) : [] });
          }}
        />)
    }
    {
      notAssignedRanges.map((range, i) => {
        const checked = R.contains(i, selected);
        return (
          <Checkbox
            key={i}
            label={DateUtils.displayRange(range)}
            checked={checked}
            onCheck={() => {
              const value = !checked ? R.append(i, selected) : R.reject(R.equals(i), selected);
              onChange({
                keyPath: ['data', 'missingDatesIndexSelected'],
                value,
              });
            }}
          />
        );
      })
    }
    <br/>
    <b>Step Two: Assign to Season</b>
    {
      existingSeasons.map((season, i) => (
        <RadioButton
          key={i}
          checked={R.equals(i, data.assignToSeasonIndex)}
          label={season.seasonName}
          labelStyle={{ color: seasonColors[i] }}
          onCheck={() => onChange({
            keyPath: ['data', 'assignToSeasonIndex'],
            value: i,
          })}
        />
      ))
    }
    <RadioButton
      label="CREATE NEW SEASON"
      checked={R.equals(-1, data.assignToSeasonIndex)}
      onCheck={() => onChange({ keyPath: ['data', 'assignToSeasonIndex'], value: -1 })}
    />
    {
      R.equals(-1, data.assignToSeasonIndex) ? (
        <SelectSeasonName
          labelNode={
            <label
              style={{ display: 'block', margin: '0 0 8px 4px', fontSize: '13px' }}
            >
              Season Name
              <span style={{ color: '#f44336', marginLeft: '6px' }}>* Required</span>
            </label>}
          style={{ width: '70%', marginLeft: '5%' }}
          selectedSeasonName={data.newSeasonName}
          contractingPeriod={contractingPeriod}
          existingSeasons={existingSeasons}
          onChange={value => onChange({ keyPath: ['data', 'newSeasonName'], value })}
        />
      ) : <span/>
    }
    <br/>
    <b>Step Three:</b>
    <RaisedButton
      label="Assign"
      secondary
      style={{ marginLeft: '8px' }}
      disabled={!assignInProgress || (data.assignToSeasonIndex === -1 && !data.newSeasonName)}
      onTouchTap={() => {
        const selectedRanges = notAssignedRanges.filter((_, j) => R.contains(j, data.missingDatesIndexSelected))
          .map(naRange => ({ seasonStartDate: moment.utc(naRange.from).format(), seasonEndDate: moment.utc(naRange.to || naRange.from).format() }));
        const newExistingSeasons = data.assignToSeasonIndex > -1 ? existingSeasons.map((season, i) => {
          if (i === data.assignToSeasonIndex) return R.merge(season, { dateRanges: R.concat(season.dateRanges, selectedRanges) });
          return season;
        }) : R.append({ seasonName: data.newSeasonName, dateRanges: selectedRanges }, existingSeasons);
        // if there is no more dates to be assigned
        // NOTE: existingSeasons hasn't been updated at this point so notAssignedRanges won't be empty, check isNilOrEmpty(notAssignedRanges) won't work
        if (notAssignedRanges.length === data.missingDatesIndexSelected.length) {
          onChange({ keyPath: ['data', 'seasonIndex'], value: data.assignToSeasonIndex > -1 ? data.assignToSeasonIndex : existingSeasons.length });
        }
        onChange({
          keyPath: ['data', 'existingSeasons'],
          value: newExistingSeasons,
        });
      }}
    />
    <div>
      {
        assignInProgress ? "Note: Dates won't be assigned until the ASSIGN button is clicked." : ''
      }
    </div>
  </div>);
};

export default AssignDateRanges;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/edit-seasons/assign-date-ranges.jsx